import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {Observable} from 'rxjs';
import {NewFile} from '../../components/documentazione/new-file';

@Component({
  selector: 'lib-tabella-documenti',
  templateUrl: './tabella-documenti.component.html',
  styleUrls: ['./tabella-documenti.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class TabellaDocumentiComponent implements OnInit {
  @Input()
  files$: Observable<Array<NewFile>>;
  @Output()
  indiceSelezionato: EventEmitter<number> = new EventEmitter<number>();

  displayedFiles$: Observable<Array<NewFile>>;

    constructor() { }

  ngOnInit(): void {}

}
